export default function FlightLabelFilter(l10nService) {
    'ngInject';
                const pattern = new RegExp('flight', 'gi');
                return function(input, item, upperCase) {
                    let itemForReturn;

                    if (!item) {
                        return input;
                    }
                    itemForReturn = isTrain(item.toLowerCase()) ? 'train' : 'flight';
                    itemForReturn = upperCase ? capitalizeFirstLetter(itemForReturn) : itemForReturn;

                    return l10nService.localize(input.replace(pattern, itemForReturn));

                    function isTrain(itemToCheck) {
                        return (itemToCheck === 'train' || itemToCheck === 'eurostar' || itemToCheck === 'amtrak');
                    }

                    function capitalizeFirstLetter(string) {
                        return string.charAt(0).toUpperCase() + string.slice(1);
                    }
                };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/filters/flightLabel.filter.js